import { render, staticRenderFns } from "./UserCheckoutSummary.vue?vue&type=template&id=66cf6584&scoped=true&"
import script from "./UserCheckoutSummary.vue?vue&type=script&lang=js&"
export * from "./UserCheckoutSummary.vue?vue&type=script&lang=js&"
import style0 from "./UserCheckoutSummary.vue?vue&type=style&index=0&id=66cf6584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf6584",
  null
  
)

export default component.exports